import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Svg from '../shared/Svg';
import { showTimeReminder } from '../../actions/time';
import './StatusBarTimeReminder.scss';
import { handleAddTime } from '../../utils/time';

export const StatusBarTimeReminder = () => {
  const dispatch = useDispatch();
  const isErrorLoadingTimeConfig = useSelector((state) => state.time.isErrorLoadingTimeConfig);
  const timeTrackingMode = useSelector((state) => state.mail.settings.timeSettings?.timeTrackingMode);
  const isEmailSaved = useSelector((state) => state.mail.isEmailSaved);
  const allEmailsSaved = Object.values(isEmailSaved).every((value) => value === true);
  const isSavingToTimeline = useSelector((state) => state.mail.isSavingToTimeline);
  const activityTimelineChecked = allEmailsSaved || isSavingToTimeline;
  const checkActivityTimeline = timeTrackingMode === 'timeReminder' && !activityTimelineChecked;
  const objectsConfiguredForTime = useSelector((state) => state.time?.config?.objectsConfiguredForTime) || [];
  const allSelectedRecords = useSelector((state) => state.mail.selectedRecords);
  const selectedRecords = Object.fromEntries(Object.entries(allSelectedRecords).filter(([key, obj]) => objectsConfiguredForTime.includes(obj.type))) || {};
  const timeConfigFields = useSelector((state) => state.time.config?.fields);

  return (
    <div className='time-reminder-container'>
      <Svg
        className='time-reminder-icon'
        data='/assets/time.svg'
      />
      <div className='time-reminder-text'>
        <p>Don&apos;t forget to <u className='time-reminder-text-link' onClick={() => handleAddTime(isErrorLoadingTimeConfig, dispatch, true, checkActivityTimeline, selectedRecords, timeConfigFields) }>Add Time!</u></p>
      </div>
      <div className='time-reminder-text time-reminder-dismiss'>
        <p><u className='time-reminder-text-link' onClick={() => dispatch(showTimeReminder(false)) }>Dismiss</u></p>
      </div>
    </div>
  );
};
